import React from 'react';
import { Link } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import { useSupervisorAuth } from '../../context/SupervisorAuthContext';
import './SupervisorCentralPage.css';

// Memes 3 tuiles que le dropdown "Central" du nav (SupervisorLayout.jsx) —
// redondance volontaire, meme convention que SupervisorReportsPage.jsx. Gates
// par SupervisorMenuPermission (2026-09-17).
const centralItems = [
  { label: 'Suivi des ventes', icon: '🖥️', path: '/supervisor/sales-monitoring' },
  { label: 'Banques Connecte', icon: '🏦', path: '/supervisor/banques-connecte' },
  { label: 'Verifier le Ticket', icon: '👤', path: '/supervisor/verifier-ticket' },
  { label: 'Numeros gagnants', icon: '🔄', path: '/supervisor/winning-numbers' },
  { label: 'Fermer Vente', icon: '🔒', path: '/supervisor/close-sales' },
  { label: 'Voir Parametres', icon: '👤', path: '/supervisor/see-parameters' },
  // Le reste du Central company (2026-09-26), toujours limite a SES banks :
  { label: 'Suivi Express', icon: '🖥️', path: '/supervisor/express-monitoring' },
  { label: 'Changer mot de passe POS', icon: '⚙️', path: '/supervisor/change-terminal-password' },
  { label: 'Annuler une fiche', icon: '🚫', path: '/supervisor/nullify-ticket' },
  { label: 'Retablir une fiche annulee', icon: '↩️', path: '/supervisor/revert-nullified-ticket' },
  { label: 'Payer une fiche', icon: '💵', path: '/supervisor/pay-ticket' },
];

const SupervisorCentralPage = () => {
  const { supervisor } = useSupervisorAuth();
  const granted = new Set(supervisor?.menu_keys || []);
  const visibleItems = centralItems.filter((item) => granted.has(item.path));

  return (
    <SupervisorLayout>
      <p className="svc-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svc-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/central" className="svc-link">Central</Link>
      </p>

      <div className="svc-grid">
        {visibleItems.map((item) => (
          <Link key={item.label} to={item.path} className="svc-item">
            <div className="svc-icon">{item.icon}</div>
            <span className="svc-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorCentralPage;
